import React, { useEffect } from "react";
import { Accordion } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { Controller, useFormContext } from "react-hook-form";
import { RecekTextField } from "../inputs";
import css from "./ProductMeasuresSection.module.css";
/** The three measure groups (unit / carton / pallet). */
var GROUPS = [
    { key: "unitMeasures", labelId: "ui-br-agency.product.measures.unit.label" },
    {
        key: "cartonMeasures",
        labelId: "ui-br-agency.product.measures.carton.label",
    },
    {
        key: "palletMeasures",
        labelId: "ui-br-agency.product.measures.pallet.label",
    },
];
/** The four measured dimensions shown as columns. */
var FIELDS = [
    { key: "height", labelId: "ui-br-agency.product.measures.height.label" },
    { key: "width", labelId: "ui-br-agency.product.measures.width.label" },
    {
        key: "thickness",
        labelId: "ui-br-agency.product.measures.thickness.label",
    },
    { key: "weight", labelId: "ui-br-agency.product.measures.weight.label" },
];
export var ProductMeasuresSection = function (_a) {
    var open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    var _b = useFormContext(), control = _b.control, _c = _b.formState, errors = _c.errors, submitCount = _c.submitCount;
    var hasMeasureError = GROUPS.some(function (group) { return !!errors[group.key]; });
    // A failed save must never be silent: when a measure is invalid while the
    // section is collapsed, expand it so the field message is visible. Keyed on
    // submitCount so it reacts to each save attempt, not to the user collapsing.
    useEffect(function () {
        if (submitCount > 0 && hasMeasureError && open === false) {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitCount]);
    return (React.createElement(Accordion, { label: formatMessage({ id: "ui-br-agency.product.accordion.measures" }), open: open, onToggle: onToggle },
        React.createElement("div", { className: css.grid },
            React.createElement("span", null),
            FIELDS.map(function (f) { return (React.createElement("span", { key: f.key, className: css.colHead }, formatMessage({ id: f.labelId }))); }),
            GROUPS.map(function (group) { return (React.createElement(React.Fragment, { key: group.key },
                React.createElement("span", { className: css.rowHead }, formatMessage({ id: group.labelId })),
                FIELDS.map(function (f) { return (React.createElement(Controller, { key: f.key, control: control, name: "".concat(group.key, ".").concat(f.key), render: function (_a) {
                        var _b, _c;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, { labelId: f.labelId, showLabel: false, "aria-label": formatMessage({ id: f.labelId }), 
                            // Plain text, not type="number": no spinner, and the mouse
                            // wheel / arrow keys cannot change (or negate) the value.
                            inputMode: "numeric", marginBottom0: true, name: field.name, value: (_b = field.value) !== null && _b !== void 0 ? _b : "", onChange: field.onChange, onBlur: field.onBlur, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message }));
                    } })); }))); }))));
};
